import React from "react";

export default function Welcome(props) {
  return (
    <div className="mb-5">
      <h1 className="pacifico-text mt-5">Welcome to My Text-Change React App!</h1>
      <p className="quicksand-text my-3">
        TRANSFORM YOUR TEXT WITH JUST A CLICK! WHETHER YOU WANT TO SHOUT IN
        UPPERCASE, WHISPER IN LOWERCASE, OR ADD SOME BOLD AND ITALIC FLAIR, THIS
        APP HAS GOT YOU COVERED. BUILT WITH ❤️ BY 
        <span className="fs-5 lexend-text">
        <strong>
           Ansar Malik
        </strong>
        </span>
        , THIS IS YOUR GO-TO TOOL FOR ALL THINGS TEXT MANIPULATION. LET’S MAKE
        YOUR WORDS STAND OUT!
      </p>
    </div>
  );
}
